<template>
  <span>
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"
    ></loading>
    <!-- <v-flex md12>
          <h2>{{ $t('custom.analitics') }}</h2>
        </v-flex> -->
    <v-container fluid fill-height>
      <!-- <v-layout> -->

      <v-toolbar
        text
        :color="$vuetify.theme.dark ? '' : 'white'"
        class="align-center"
      >
        <v-toolbar-title
          >{{ $t("analitics.common_clients") }} {{ $t("custom.number")
          }}{{ report.id }} {{ start_date_formatted }} -
          {{ end_date_formatted }} ({{ getBranchName() }})</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="mr-2"
          icon
          @click="recalculateReport"
          :title="$t('analitics.recalculate')"
          :loading="isRecalculating"
          :disabled="isRecalculating || isGenerating"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn
          icon
          :href="docsLink('/analitika/otchyoty')"
          target="_blank"
        >
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
      </v-toolbar>
      
      <!-- Индикатор генерации отчета -->
      <v-flex v-if="isGenerating && !generationError" md12 class="mb-4 mt-4">
        <v-alert
          type="info"
          border="left"
          colored-border
          class="mb-4"
        >
          <v-row align="center">
            <v-col class="grow">
              <div class="text-h6">{{ $t('analitics.report_generating') }}</div>
              <div class="text-caption">
                <span v-if="connected" class="success--text">● {{ $t('analitics.connected') }}</span>
                <span v-else class="error--text">● {{ $t('analitics.disconnected') }}</span>
              </div>
            </v-col>
          </v-row>
          <v-progress-linear
            :value="reportProgress"
            color="primary"
            height="20"
            class="mt-3"
            striped
          >
            <template v-slot:default>
              <strong>{{ reportProgress.toFixed(0) }}%</strong>
            </template>
          </v-progress-linear>
        </v-alert>
      </v-flex>
      
      <!-- Ошибка генерации отчета -->
      <v-flex v-if="generationError" md12 class="mb-4 mt-4">
        <v-alert type="error" border="left" colored-border class="mb-4">
          <v-row align="center">
            <v-col class="grow">
              <div class="text-h6">{{ $t('analitics.report_generation_error') }}</div>
              <div class="text-body-2 mt-2">{{ generationError }}</div>
            </v-col>
          </v-row>
          <v-btn color="error" outlined class="mt-3" @click="retryGeneration">
            <v-icon left>mdi-refresh</v-icon>
            {{ $t('analitics.try_again') }}
          </v-btn>
        </v-alert>
      </v-flex>
      
      <!-- По клиентам -->
      <v-flex v-if="report.state == 'created'" md12>
        <!-- Графики -->
        <v-card-text v-if="showCharts">
          <v-expansion-panels v-model="chartsPanel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span class="subtitle-1 font-weight-medium">
                  <v-icon left color="primary">mdi-chart-bar</v-icon>
                  {{ $t("analitics.visual_analytics") }}
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <!-- Эффективность рекламы: Карточки с метриками -->
                  <v-col cols="12">
                    <v-row>
                      <!-- Всего новых клиентов -->
                      <v-col cols="12" sm="6" md="3">
                        <v-card color="info" dark elevation="2" class="metrics-card">
                          <v-card-text class="d-flex align-center justify-space-between pa-3">
                            <div class="d-flex align-center">
                              <v-icon size="32" class="mr-2">mdi-account-multiple</v-icon>
                              <span class="body-2">{{ $t("analitics.total_new_clients") }}</span>
                            </div>
                            <div class="text-h6 font-weight-bold">
                              {{ report.new_clients_count || 0 }}
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>

                       <!-- Повторные клиенты -->
                       <v-col cols="12" sm="6" md="3">
                        <v-card color="warning" dark elevation="2" class="metrics-card">
                          <v-card-text class="d-flex align-center justify-space-between pa-3">
                            <div class="d-flex align-center">
                              <v-icon size="32" class="mr-2">mdi-account-repeat</v-icon>
                              <span class="body-2">{{ $t("analitics.repeat_clients") }}</span>
                            </div>
                            <div class="text-h6 font-weight-bold">
                              {{ report.repeat_clients_count || 0 }}
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <!-- Конверсия -->
                      <v-col cols="12" sm="6" md="3">
                        <v-card color="success" dark elevation="2" class="metrics-card">
                          <v-card-text class="d-flex align-center justify-space-between pa-3">
                            <div class="d-flex align-center">
                              <v-icon size="32" class="mr-2">mdi-chart-line</v-icon>
                              <div>
                                <div class="body-2">{{ $t("analitics.convertion") }}</div>
                                <div class="caption grey--text text--lighten-2">
                                  {{ report.active_clients || 0 }} {{ $t("analitics.made_booking_short") }}
                                </div>
                              </div>
                            </div>
                            <div class="text-h6 font-weight-bold">
                              {{ (report.convertion || 0).toFixed(1) }}%
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <!-- Стоимость активного клиента -->
                      <v-col cols="12" sm="6" md="3">
                        <v-card color="primary" dark elevation="2" class="metrics-card">
                          <v-card-text class="d-flex align-center justify-space-between pa-3">
                            <div class="d-flex align-center">
                              <v-icon size="32" class="mr-2">mdi-cash</v-icon>
                              <span class="body-2">{{ $t("analitics.cost_per_active") }}</span>
                            </div>
                            <div class="text-h6 font-weight-bold">
                              {{ (report.attract_active_client_cost || 0).toLocaleString() }}
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- Воронка конверсии -->
                  <v-col cols="12" md="6" v-if="conversionChartData && conversionChartData.length > 1">
                    <!-- <h3 class="mb-3">{{ $t("analitics.conversion_funnel") }}</h3> -->
                    <GChart
                      style="width: 100%; min-height: 400px"
                      type="ColumnChart"
                      :options="conversionChartOptions"
                      :settings="{
                        packages: ['corechart'],
                        language: this.$i18n.locale,
                      }"
                      :data="conversionChartData"
                    />
                  </v-col>

                  <!-- Стоимость привлечения -->
                  <v-col cols="12" md="6" v-if="acquisitionChartData && acquisitionChartData.length > 1">
                    <!-- <h3 class="mb-3">{{ $t("analitics.acquisition_cost") }}</h3> -->
                    <GChart
                      style="width: 100%; min-height: 400px"
                      type="BarChart"
                      :options="acquisitionChartOptions"
                      :settings="{
                        packages: ['corechart'],
                        language: this.$i18n.locale,
                      }"
                      :data="acquisitionChartData"
                    />
                  </v-col>

                  <!-- Общие показатели (выручка и расходы) -->
                  <v-col cols="12" md="6" v-if="revenueExpensesChartData && revenueExpensesChartData.length > 1">
                    <!-- <h3 class="mb-3">{{ $t("analitics.revenue_and_expenses") }}</h3> -->
                    <GChart
                      style="width: 100%; min-height: 400px"
                      type="PieChart"
                      :options="revenueExpensesChartOptions"
                      :settings="{
                        packages: ['corechart'],
                        language: this.$i18n.locale,
                      }"
                      :data="revenueExpensesChartData"
                    />
                  </v-col>

                  <!-- Средние показатели на клиента -->
                  <v-col cols="12" md="6" v-if="metricsChartData && metricsChartData.length > 1">
                    <!-- <h3 class="mb-3">{{ $t("analitics.average_per_client") }}</h3> -->
                    <GChart
                      style="width: 100%; min-height: 400px"
                      type="BarChart"
                      :options="metricsChartOptions"
                      :settings="{
                        packages: ['corechart'],
                        language: this.$i18n.locale,
                      }"
                      :data="metricsChartData"
                    />
                  </v-col>

                  <!-- Новые графики с расширенной аналитикой -->
                  <template v-if="hasExtendedAnalytics">
                    <!-- Источники клиентов -->
                    <v-col cols="12" md="6" v-if="sourceChartData && sourceChartData.length > 1">
                      <!-- <h3 class="mb-3">{{ $t("analitics.clients_by_source") }}</h3> -->
                      <GChart
                        style="width: 100%; min-height: 400px"
                        type="PieChart"
                        :options="sourceChartOptions"
                        :settings="{
                          packages: ['corechart'],
                          language: this.$i18n.locale,
                        }"
                        :data="sourceChartData"
                      />
                    </v-col>

                    <!-- Топ-10 клиентов -->
                    <v-col cols="12" md="6" v-if="topClientsChartData && topClientsChartData.length > 1">
                      <!-- <h3 class="mb-3">{{ $t("analitics.top_clients_revenue") }}</h3> -->
                      <GChart
                        style="width: 100%; min-height: 400px"
                        type="BarChart"
                        :options="topClientsChartOptions"
                        :settings="{
                          packages: ['corechart'],
                          language: this.$i18n.locale,
                        }"
                        :data="topClientsChartData"
                      />
                    </v-col>

                    <!-- Новые vs Повторные клиенты -->
                    <v-col cols="12" md="6" v-if="repeatClientsChartData && repeatClientsChartData.length > 1">
                      <!-- <h3 class="mb-3">{{ $t("analitics.new_vs_repeat_clients") }}</h3> -->
                      <GChart
                        style="width: 100%; min-height: 400px"
                        type="PieChart"
                        :options="repeatClientsChartOptions"
                        :settings="{
                          packages: ['corechart'],
                          language: this.$i18n.locale,
                        }"
                        :data="repeatClientsChartData"
                      />
                    </v-col>

                    <!-- ROI рекламной кампании -->
                    <v-col cols="12" md="6" v-if="adsRoiChartData && adsRoiChartData.length > 1">
                      <GChart
                        style="width: 100%; min-height: 300px"
                        type="ColumnChart"
                        :options="adsRoiChartOptions"
                        :settings="{
                          packages: ['corechart'],
                          language: this.$i18n.locale,
                        }"
                        :data="adsRoiChartData"
                      />
                    </v-col>

                    <!-- Конверсия по источникам -->
                    <v-col cols="12" md="12" v-if="conversionBySourceChartData && conversionBySourceChartData.length > 1">
                      <!-- <h3 class="mb-3">{{ $t("analitics.conversion_by_source") }}</h3> -->
                      <GChart
                        style="width: 100%; min-height: 400px"
                        type="ColumnChart"
                        :options="conversionBySourceChartOptions"
                        :settings="{
                          packages: ['corechart'],
                          language: this.$i18n.locale,
                        }"
                        :data="conversionBySourceChartData"
                      />
                    </v-col>
                  </template>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-text>
          <v-toolbar text :color="$vuetify.theme.dark ? '' : 'white'">
            <h2>{{ $t("analitics.average_indicators") }}</h2>
          </v-toolbar>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">
                    {{ $t("analitics.new_clients") }}
                  </th>
                  <th class="text-center">
                    {{ $t("analitics.new_active_clients") }}
                  </th>
                  <th class="text-center">
                    {{ $t("analitics.active_clients") }}
                  </th>
                  <th class="text-center">
                    {{ $t("analitics.convertion") }}
                  </th>
                  <th class="text-center">
                    {{ $t("analitics.ads_expences") }}
                  </th>
                  <th class="text-center">
                    {{ $t("analitics.ads_expences_one") }}
                  </th>
                  <th class="text-center">
                    {{ $t("analitics.ads_expences_one_active") }}
                  </th>
                  <th class="text-center">
                    {{ $t("analitics.revenue") }}
                  </th>
                  <th class="text-center">
                    {{ $t("analitics.revenue_per_active_client") }}
                  </th>
                  <!-- <th class="text-center">
                    {{ $t("analitics.revenue_per_client") }}
                  </th> -->
                  <!-- <th class="text-center">
                    {{ $t("analitics.average_mileage") }}
                  </th> -->
                  <th class="text-center">
                    {{ $t("analitics.average_mileage_day") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">
                    {{ report.new_clients_count }}
                  </td>
                  <td class="text-center">
                    {{ report.new_active_clients }}
                  </td>
                  <td class="text-center">
                    {{ report.active_clients }}
                  </td>
                  <td class="text-center">
                    {{ parseFloat(report.convertion).toFixed(2) }}%
                  </td>
                  <td class="text-center">
                    {{ parseInt(report.ads_expences) }}
                  </td>
                  <td class="text-center">
                    {{ parseFloat(report.attract_client_cost).toFixed(2) }}
                  </td>
                  <td class="text-center">
                    {{ parseFloat(report.attract_active_client_cost).toFixed(2) }}
                  </td>
                  <td class="text-center">
                    {{ parseFloat(report.revenue).toFixed(2) }}
                  </td>
                  <td class="text-center">
                    {{ parseFloat((report.revenue || 0) / (report.active_clients || 1)).toFixed(2) }}
                  </td>
                  <!-- <td class="text-center">
                    {{ parseFloat((report.revenue || 0) / (report.new_clients_count || 1)).toFixed(2) }}
                  </td> -->
                  <!-- <td class="text-center">
                    {{ parseInt(report.mileage_per_active_client) }}
                    {{ $t("custom.km") }}
                  </td> -->
                  <td class="text-center">
                    {{ parseInt(report.daily_mileage_for_client) }}
                    {{ $t("custom.km") }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-flex>
      <v-flex v-else md12 class="text-center mt-10">
        {{ $t("analitics.report_in_progress") }}
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
        <br />
        <v-btn @click="$router.go()">{{ $t("custom.update") }}</v-btn>
      </v-flex>
    </v-container>
  </span>
</template>
<script>
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { GChart } from "vue-google-charts";
import { Capacitor } from "@capacitor/core";
import CableSubscriber from "@/mixins/CableSubscriber";
import { formatPhone } from "@/lib/phone/display";
export default {
  mixins: [CableSubscriber],
  pullToRefresh: true,
  data() {
    return {
      report: {},
      showCharts: false,
      chartsPanel: [0],
      isLoading: false,
      error: "",
      // WebSocket статус
      isGenerating: false,
      isRecalculating: false,
      connected: false,
      reportProgress: 0,
      generationError: null,
      // Данные о филиалах
      branches: [],
      current_branch_name: ''
    };
  },
  mounted() {
    let self = this;
  },
  beforeDestroy() {
    // Отписываемся от WebSocket при уничтожении компонента
    this.unsubscribeFromReport()
  },
  created() {
    setMomentLocale(this.$i18n.locale);
    if (
      this.$store.getters.isLoggedIn &&
      (this.$store.getters.isSuperAdmin ||
        this.$store.getters.isAdmin ||
        this.$store.getters.isGuest)
    ) {
      this.isLoading = true;
      this.loadReport();
    } else {
      this.$router.push({ path: `/dashboard` }).catch((err) => {});
      this.$notify(this.$t("errors.only_admins"), "", "warning", 5000);
    }
  },
  computed: {
    start_date_formatted() {
      return moment(this.report.start_date).format("DD.MM.YYYY");
    },
    end_date_formatted() {
      return moment(this.report.end_date).format("DD.MM.YYYY");
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    isIos() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ? true : false;
    },
    // Проверка наличия расширенной аналитики (для обратной совместимости)
    hasExtendedAnalytics() {
      // Проверяем только реальные данные, не дефолтные значения
      const hasSources = this.report.sources_data && 
        typeof this.report.sources_data === 'object' &&
        Object.keys(this.report.sources_data).length > 0;
      const hasTopClients = this.report.top_clients_data && 
        Array.isArray(this.report.top_clients_data) &&
        this.report.top_clients_data.length > 0;
      
      // Возвращаем true только если есть хоть какие-то реальные данные
      return !!(hasSources || hasTopClients);
    },
    // Опции графиков с поддержкой темной темы
    conversionChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.conversion_funnel"),
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: "none" },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#2196F3", "#4CAF50", "#FF9800"],
      };
    },
    acquisitionChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.acquisition_cost"),
        chartArea: { width: "60%" },
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: "none" },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#FF5722", "#FFC107"],
      };
    },
    revenueExpensesChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.revenue_and_expenses"),
        pieHole: 0.4,
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#4CAF50", "#F44336"],
      };
    },
    revenueExpensesChartData() {
      if (!this.report || !this.report.state) return [];
      return [
        [this.$t("custom.metric"), this.$t("custom.value")],
        [
          this.$t("analitics.revenue"),
          parseFloat(this.report.revenue || 0),
        ],
        [
          this.$t("analitics.ads_expences"),
          parseFloat(this.report.ads_expences || 0),
        ],
      ];
    },
    metricsChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.average_per_client"),
        chartArea: { width: "60%" },
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: "none" },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#2196F3"],
      };
    },
    adsRoiChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.ads_roi"),
        chartArea: { width: "70%" },
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: "none" },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          format: "short",
        },
        annotations: {
          textStyle: {
            fontSize: 12,
            color: isDark ? "#FFFFFF" : "#000000",
          },
        },
        colors: ["#F44336", "#4CAF50"],
      };
    },
    // Данные графиков
    adsRoiChartData() {
      if (!this.report || !this.report.state) return [];
      const revenue = parseFloat(this.report.revenue || 0);
      const ads = parseFloat(this.report.ads_expences || 0);
      const roi = ads > 0 ? ((revenue / ads) * 100).toFixed(0) : 0;
      
      return [
        [this.$t("custom.metric"), this.$t("custom.amount"), { role: 'annotation' }],
        [this.$t("analitics.ads_expences"), ads, ads.toLocaleString()],
        [this.$t("analitics.revenue"), revenue, revenue.toLocaleString()],
      ];
    },
    conversionChartData() {
      if (!this.report || !this.report.state) return [];
      return [
        [this.$t("custom.stage"), this.$t("custom.count")],
        [this.$t("analitics.new_clients"), this.report.new_clients_count || 0],
        [
          this.$t("analitics.new_active_clients"),
          this.report.new_active_clients || 0,
        ],
        [this.$t("analitics.active_clients"), this.report.active_clients || 0],
      ];
    },
    acquisitionChartData() {
      if (!this.report || !this.report.state) return [];
      return [
        [this.$t("custom.metric"), this.$t("custom.cost")],
        [
          this.$t("analitics.ads_expences_one"),
          parseFloat(this.report.attract_client_cost || 0),
        ],
        [
          this.$t("analitics.ads_expences_one_active"),
          parseFloat(this.report.attract_active_client_cost || 0),
        ],
      ];
    },
    metricsChartData() {
      if (!this.report || !this.report.state) return [];
      const activeClients = this.report.active_clients || 1;
      const allClients = this.report.new_clients_count || 1;
      
      return [
        [this.$t("custom.metric"), this.$t("custom.value")],
        [
          this.$t("analitics.revenue_per_active_client"),
          parseFloat((this.report.revenue || 0) / activeClients),
        ],
        [
          this.$t("analitics.revenue_per_client"),
          parseFloat((this.report.revenue || 0) / allClients),
        ],
        [
          this.$t("analitics.ads_expences_one_active"),
          parseFloat(this.report.attract_active_client_cost || 0),
        ],
      ];
    },
    // === Новые графики с расширенной аналитикой ===
    sourceChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.clients_by_source"),
        pieHole: 0.4,
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
      };
    },
    sourceChartData() {
      if (!this.report.sources_data || Object.keys(this.report.sources_data).length === 0) return [];
      const data = [[this.$t("custom.source"), this.$t("custom.count")]];
      Object.entries(this.report.sources_data).forEach(([source, stats]) => {
        data.push([source, stats.total]);
      });
      return data;
    },
    topClientsChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.top_clients_revenue"),
        chartArea: { width: "60%" },
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: "none" },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#4CAF50"],
      };
    },
    topClientsChartData() {
      if (!this.report.top_clients_data || this.report.top_clients_data.length === 0) return [];
      const data = [[this.$t("custom.client"), this.$t("analitics.revenue")]];
      this.report.top_clients_data.forEach((client) => {
        // Используем name или phone если name пустое
        const clientName = client.name || formatPhone(client.phone) || `ID: ${client.id}`;
        data.push([clientName, parseFloat(client.revenue || 0)]);
      });
      return data;
    },
    repeatClientsChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.new_vs_repeat_clients"),
        pieHole: 0.4,
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#2196F3", "#FF9800"],
      };
    },
    repeatClientsChartData() {
      if (this.report.repeat_clients_count === undefined || 
          this.report.repeat_clients_count === null) return [];
      const newClients = (this.report.new_active_clients || 0) - (this.report.repeat_clients_count || 0);
      const repeatCount = this.report.repeat_clients_count || 0;
      // Проверяем что есть хоть какие-то данные для отображения
      if (newClients === 0 && repeatCount === 0) return [];
      return [
        [this.$t("custom.type"), this.$t("custom.count")],
        [this.$t("analitics.new_clients"), Math.max(0, newClients)],
        [this.$t("analitics.repeat_clients"), repeatCount],
      ];
    },
    conversionBySourceChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.conversion_by_source"),
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: "none" },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          title: this.$t("analitics.convertion") + " (%)",
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        annotations: {
          textStyle: {
            fontSize: 11,
            color: isDark ? "#FFFFFF" : "#000000",
            bold: true,
          },
          alwaysOutside: true,
        },
        colors: ["#9C27B0"],
      };
    },
    conversionBySourceChartData() {
      if (!this.report.sources_data || Object.keys(this.report.sources_data).length === 0) return [];
      const data = [[this.$t("custom.source"), this.$t("analitics.convertion"), { role: 'annotation' }]];
      Object.entries(this.report.sources_data).forEach(([source, stats]) => {
        if (stats.conversion > 0) {
          const activeCount = stats.active || 0;
          data.push([source, stats.conversion, `${stats.conversion.toFixed(1)}% (${activeCount})`]);
        }
      });
      return data;
    },
  },
  methods: {
    getBranchName() {
      if (this.report.all_branches) {
        return this.$t('custom.all_branches');
      }
      
      if (this.report.company_id) {
        const branch = this.branches.find(b => b.id === this.report.company_id);
        return branch ? branch.name : this.current_branch_name;
      }
      
      return this.current_branch_name;
    },
    loadReport() {
      this.axios
        .get(`/api/v1/clients_reports/${this.$route.params.query}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.report = response.data;
          this.branches = response.data.branches || [];
          this.current_branch_name = response.data.current_branch_name || '';
          
          // Если отчет в статусе initial или pending, подписываемся на обновления
          if (this.report.state === 'initial' || this.report.state === 'pending') {
            this.isGenerating = true
            this.subscribeToReportUpdates()
          }
          
          if (response.data.state == "created") {
            this.showCharts = true;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.clients_report_load"));
          console.log(error);
          this.isLoading = false;
        });
    },
    
    // FT-066: ReportsChannel handlers (moved from the old channels option; this-rebinding via
    // arrows in subscribeToReportUpdates). Bodies are 1:1 with the former declarative channel.
    onReportConnected() {
      console.log('Connected to ReportsChannel for clients report')
      this.connected = true
    },
    onReportDisconnected() {
      console.log('Disconnected from ReportsChannel')
      this.connected = false
    },
    onReportReceived(data) {
      console.log('Report progress received:', data)

      if (data.report_id === this.report.id) {
        this.reportProgress = data.progress

        if (data.status === 'completed') {
          console.log('✅ Report generation completed!')
          this.isGenerating = false
          this.loadReport()

          this.$notify(
            this.$t('analitics.report_ready'),
            this.$t('analitics.report_generated_successfully'),
            'success',
            5000
          )
        }

        if (data.status === 'failed') {
          this.isGenerating = false
          this.generationError = data.error || this.$t('analitics.report_generation_failed')

          this.$notify(this.$t('errors.error'), this.generationError, 'error', 5000)
        }
      }
    },

    subscribeToReportUpdates() {
      if (this.report && this.report.id) {
        // FT-066 switch pattern: drop any prior sub before re-subscribing.
        this.$cableUnsubscribe(this.reportSub)
        this.reportSub = this.$cableSubscribe(
          {
            channel: 'ReportsChannel',
            report_type: 'clients',
            report_id: this.report.id
          },
          {
            connected: () => this.onReportConnected(),
            disconnected: () => this.onReportDisconnected(),
            received: (data) => this.onReportReceived(data)
          }
        )
        console.log('✅ Subscribed to ReportsChannel for clients report', this.report.id)
      }
    },

    unsubscribeFromReport() {
      this.$cableUnsubscribe(this.reportSub)
      this.reportSub = null
    },
    
    recalculateReport() {
      if (!this.report || !this.report.id || this.isRecalculating) {
        return
      }

      this.isRecalculating = true
      this.generationError = null
      this.isGenerating = true
      this.reportProgress = 0

      this.unsubscribeFromReport()

      this.axios
        .post(`/api/v1/clients_reports/${this.report.id}/recalculate`, {}, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then(() => {
          if (this.report) {
            this.report.state = 'pending'
          }
          this.subscribeToReportUpdates()
          this.$notify(
            this.$t('analitics.report_recalculation_started'),
            '',
            'success',
            3000
          )
        })
        .catch((error) => {
          this.isGenerating = false
          const message =
            (error.response && error.response?.data && error.response?.data.error) ||
            this.$t('analitics.report_recalculation_failed')
          let localizedMessage = message
          if (message === 'Report is already being processed') {
            localizedMessage = this.$t('analitics.report_already_processing')
          } else if (message === 'Recalculation is not available for demo reports') {
            localizedMessage = this.$t('analitics.report_recalculation_failed')
          }
          this.generationError = localizedMessage
          this.$notify(this.$t('errors.error'), localizedMessage, 'error', 5000)
        })
        .finally(() => {
          this.isRecalculating = false
        })
    },

    retryGeneration() {
      // Сбрасываем ошибку и перезагружаем отчет
      this.generationError = null
      this.isGenerating = true
      this.reportProgress = 0
      this.loadReport()
    },
    
  },
  components: {
    GChart,
  },
};
</script>

<style scoped>
.metrics-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  height: 100%;
}

.metrics-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
}
</style>
